import { combineReducers } from '@reduxjs/toolkit'
import algolia from './algolia'
import yape from './yape'

const rootReducer = combineReducers({
  algolia,
  yape,
})

export default rootReducer
